<template>
  <div class="new-order notice-base check-order">
    <span class="title">查看发货通知单</span>
    <el-divider/>
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="基本信息">
          <el-form ref="form" inline v-if="dataObj.baseInfoV">
            <el-form-item label="物品类型">
              <span class="base-span">{{ dataObj.baseInfoV.goodsType }}</span>
            </el-form-item>
            <el-form-item label="类别">
              <span class="base-span">{{ dataObj.baseInfoV.type === '1' ? '内销' : '' }}</span>
            </el-form-item>
            <el-form-item label="出库日期">
              <span class="base-span">{{ dataObj.baseInfoV.deliveryTime }}</span>
            </el-form-item>
            <el-form-item label="客户名称">
              <span class="base-span">{{ dataObj.baseInfoV.custName }}</span>
            </el-form-item>
            <el-form-item label="收货人">
              <span class="base-span">{{ dataObj.baseInfoV.contactName }}</span>
            </el-form-item>
            <el-form-item label="联系方式">
              <span class="base-span">{{ dataObj.baseInfoV.contactPhone }}</span>
            </el-form-item>
            <el-form-item label="联系地址">
              <template>
                <span class="base-span" v-if="dataObj.baseInfoV.address">
                        {{ dataObj.baseInfoV.address.province || '' }}
                        {{ dataObj.baseInfoV.address.city || '' }}
                        {{ dataObj.baseInfoV.address.county || '' }}
                        {{ dataObj.baseInfoV.address.street || '' }}
                        {{ dataObj.baseInfoV.address.other || '' }}
                </span>
                <span class="base-span" v-else></span>
              </template>
            </el-form-item>
            <el-form-item label="账单地址">
              <template>
                <span class="base-span" v-if="dataObj.baseInfoV.billAddress">
                        {{ dataObj.baseInfoV.billContactName }}-{{ dataObj.baseInfoV.billContactPhone }}-
                        {{ dataObj.baseInfoV.billAddress.province || '' }}
                        {{ dataObj.baseInfoV.billAddress.city || '' }}
                        {{ dataObj.baseInfoV.billAddress.county || '' }}
                        {{ dataObj.baseInfoV.billAddress.street || '' }}
                        {{ dataObj.baseInfoV.billAddress.other || '' }}
                </span>
                <span class="base-span" v-else></span>
              </template>
            </el-form-item>
            <el-form-item label="类型">
              <span class="base-span">{{ dataObj.baseInfoV.userName }}</span>
            </el-form-item>
            <el-form-item label="下单人">
              <span class="base-span">{{ dataObj.baseInfoV.orderOperatorName }}</span>
            </el-form-item>
            <el-form-item label="中转站">
              <span class="base-span">{{ dataObj.baseInfoV.transferInfo }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span class="base-span">{{ dataObj.remark }}</span>
            </el-form-item>
          </el-form>
          <el-divider/>
          <span>物品明细</span>
          <el-table :data="goods" style="width: 100%">
            <el-table-column prop="saleOrderNo" label="销售订单编号" width="160px"/>
            <el-table-column prop="goodsNo" label="物品编号"/>
            <!-- <el-table-column prop="warehouse" label="仓库"/> -->
            <el-table-column prop="saleUnit" label="单位"/>
            <el-table-column prop="noticeMainCount" label="本次通知发货主数量"/>
            <el-table-column prop="noticeMainUnit" label="主单位"/>
            <!-- <el-table-column prop="noticeSlaveQuantity" label="本次通知件数" v-if="dataObj.userName === '大货'"/> -->
            <el-table-column prop="remark" label="备注"/>
            <el-table-column label="查看">
              <template slot-scope="scope">
                <i class="el-icon-third-fangdajing" @click="details(scope.row, scope.$index)"/>
              </template>
            </el-table-column>
          </el-table>
          <div class="total">
            <div><span>总重量：{{totalWeight}}</span></div>
            <div><span>总数量：{{totalQuantity}}</span></div>
          </div>
          <el-col :span="14">
            <div style="display: flex;">
              <div class="font-title" style="padding-top:30px;width:calc((100% - 130px) / 3 + 55px);">
                细码：{{good.goodsNo ? good.goodsNo : ''}}
              </div>
              <div class="font-title" style="padding-top:30px;">
                数量小计：{{getGoodsQuantitySum}}
              </div>
            </div>
            <el-table :data="good.pickCodeList"
                      class="new-order-table"
                      fit
                      max-height="300"
                      stripe>
                <template>
                    <el-table-column align="center" label="序号" width="50">
                        <template slot-scope="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>
                    <el-table-column label="卷号" prop="volumeCode"></el-table-column>
                    <el-table-column label="批次号" prop="batchNumSource"></el-table-column>
                    <el-table-column label="数量" prop="quantity"></el-table-column>
                    <el-table-column label="单位" width="80" prop="unit"></el-table-column>
                    <el-table-column label="库位" prop="shelf"></el-table-column>
                    <el-table-column label="色光" prop="lightGrade"></el-table-column>
                    <el-table-column label="销售订单编号" prop="saleOrderNum"></el-table-column>
                </template>
            </el-table>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="附件信息" name="附件信息">
          <el-form inline>
            <el-form-item label="附件上传">
              <file-upload-list :file-list.sync="saleFile" :isAdd="false"/>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

/**
 * @Description: 查看发货通知单
 * @Author: 菩萨蛮
 * @Date: 2020/10/10 9:19 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 * 查看批次号组件有些多余数据，有空可以删一下
 */
import CheckBatchListDialog from 'Components/order/NoticeOrder/CheckBatchListDialog';
import noticeOrderMixin from '@/mixins/order/NoticeOrderMixin';
import OrderVO from '@/class/common/OrderVO';
import NoticeOrder from '@/bean/order/NoticeOrder';
import CheckOrder from '../../../mixins/order/common/CheckOrder';
import * as math from 'mathjs';
import Settlement from '../../../components/order/Settlement';
import calculate from '../../../plugins/calculate';

export default {
  name: 'CheckNoticeOrder',
  qx: {
    pageType: 'modify',
    order: NoticeOrder
  },
  components: { CheckBatchListDialog },
  components: { Settlement },
  mixins: [CheckOrder, noticeOrderMixin, calculate],
  data() {
    return {
      order: new OrderVO(NoticeOrder),
      goods: [],
      activeName: '基本信息',
      good: {},

      instructionData: {}
    };
  },
  computed: {
    getGoodsQuantitySum() {
      let result = 0;
      if (this.good.pickCodeList && this.good.pickCodeList.length > 0) {
        this.good.pickCodeList.forEach(item => {
          result = calculate.add(result, item.quantity);
        })
      }
      return result;
    },
    totalWeight() {
      let total = 0;
      if (this.dataObj.orderList) {
        this.dataObj.orderList.forEach(item => {
          total = math.add(math.bignumber(total), math.bignumber(item.goodsWeight || 0));
        });
      }
      this.dataObj.totalWeight = total;
      return total.toFixed(1);
    },
    totalQuantity() {
      let total = 0;
      if (this.dataObj.orderList) {
        this.dataObj.orderList.forEach(item => {
          total = math.add(math.bignumber(total), math.bignumber(item.noticeMainCount || 0))
        });
      }
      this.dataObj.totalQuantity = total;
      return total;
    },
  },
  methods: {
    details(row, index) {
      this.good = {
        ...row,
        pickCodeList: []
      };
      this.instructionData.forEach(item => {
        item.goods.forEach(e => {
          if (e.contractNum === this.good.saleOrderNo
            && e.goodsNo === this.good.goodsNo) {
            this.good.pickCodeList.push(...e.pickCodeList)
          }
        })
      });
    },
    async setDefaultValue() {
      const { data } = await this.qGet(`${this.url}/${this.$route.params.id}`);
      this.order.setValue(data);
      this.goods = data.orderList.map(item => {
        let copyItem = JSON.parse(JSON.stringify(item));
        const noticeMainCount = item.orderQuantity ? item.orderQuantity : item.noticeMainCount;
        const noticeMainUnit = item.orderUnit ? item.orderUnit : item.noticeMainUnit;
        delete copyItem.orderQuantity;
        delete copyItem.orderUnit;
        return {
            ...copyItem,
            noticeMainCount,
            noticeMainUnit
        }
      });;
      this.dataObj = {
        ...data,
        ...data.baseInfoV,
        orderList: data.orderList.map(item => {
            let copyItem = JSON.parse(JSON.stringify(item));
            const noticeMainCount = item.orderQuantity ? item.orderQuantity : item.noticeMainCount;
            const noticeMainUnit = item.orderUnit ? item.orderUnit : item.noticeMainUnit;
            delete copyItem.orderQuantity;
            delete copyItem.orderUnit;
            return {
                ...copyItem,
                noticeMainCount,
                noticeMainUnit
            }
        })
      };
      this.logistics = data.logistics;
      this.settlePlans = data.baseInfoV.settlePlans;
      this.file = data.logistics.file;
      this.saleFile = data.logistics.saleFile;
      if (data.status !== 5) {
        const { data:instructionData } = await this.qGet(`warehouse/boundInstructions/notice/${data.id}`);
        this.instructionData = instructionData;
        this.good = {
          ...this.goods[0],
          pickCodeList: []
        };
        this.instructionData.forEach(item => {
          item.goods.forEach(e => {
            if (e.contractNum === this.good.saleOrderNo.split('/')[0]
              && e.goodsNo === this.good.goodsNo) {
              this.good.pickCodeList.push(...e.pickCodeList || [])
            }
          })
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.total{
  font-size: 18px;
}
.el-icon-third-fangdajing {
  color: #81DBBC;
  display: inline-block;
  height: 36px;
  width: 36px;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background: #81dbbc;
    color: white;
  }
}
</style>
